var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-toggle__wrap"},[_c('woot-button',{class:{
      'sidebar-toggle--button': true,
      'no-margin': !_vm.currentChat.id,
    },attrs:{"variant":"smooth","size":"tiny","color-scheme":"secondary","icon":"arrow-chevron-right"},on:{"click":_vm.toggleConversationLayout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }